import { render, staticRenderFns } from "./UserNavbar.vue?vue&type=template&id=60e048cf&scoped=true&"
import script from "./UserNavbar.vue?vue&type=script&lang=js&"
export * from "./UserNavbar.vue?vue&type=script&lang=js&"
import style0 from "./UserNavbar.vue?vue&type=style&index=0&id=60e048cf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e048cf",
  null
  
)

export default component.exports